import Column from './Column';

export default Column;
